import { ActivityInstance } from '@api';

/**
 * Härleder en emoji-ikon för en aktivitet i barnvyn.
 *
 * Backend saknar idag ett emoji/ikon-fält på aktiviteter (se underlag 🔴), så vi
 * härleder en fallback ur aktivitetsnamnet (nyckelord) och faller tillbaka på en
 * duration-baserad ikon. Funktionen är medvetet ren och liten så att en riktig
 * backend-ikon enkelt kan kopplas in senare (då används den istället för detta).
 */

type Keyword = { match: RegExp; emoji: string };

// Svensk-/engelsk-vänliga nyckelord → emoji. Ordningen spelar roll (först vinner).
const KEYWORDS: Keyword[] = [
  { match: /(läx|läs|bok|read|study|skol|school|matte|math)/i, emoji: '📚' },
  { match: /(rita|måla|paint|draw|pyssl|skap|art)/i, emoji: '🎨' },
  { match: /(dusch|bad|tvätt|shower|bath|hygien|borsta|tand)/i, emoji: '🚿' },
  { match: /(spring|löp|promenad|gå|walk|run|trän|sport|cykl)/i, emoji: '🏃' },
  { match: /(spel|game|tv|film|movie|youtube)/i, emoji: '🎮' },
  { match: /(äta|mat|frukost|lunch|middag|mellis|eat|food|snack)/i, emoji: '🍎' },
  { match: /(musik|sjung|spela in|piano|music|sing)/i, emoji: '🎵' },
  { match: /(ute|natur|park|skog|outside|nature)/i, emoji: '🌳' },
  { match: /(hund|katt|djur|dog|cat|pet)/i, emoji: '🐶' },
  { match: /(skriv|write|anteckn|dagbok)/i, emoji: '✏️' },
  { match: /(pussel|bygg|lego|puzzle|build)/i, emoji: '🧩' },
  { match: /(sov|vila|säng|nap|sleep|rest|bed)/i, emoji: '🛏️' },
];

// Duration-baserad fallback (matchar getActivityColor-stegen).
const durationEmoji = (duration: number): string => {
  if (duration <= 10) return '⏱️';
  if (duration <= 20) return '🟢';
  if (duration <= 30) return '🟣';
  if (duration <= 45) return '🔵';
  return '⭐';
};

export const getActivityIcon = (
  instance: Pick<ActivityInstance, 'activityName' | 'duration'>,
): string => {
  const name = instance.activityName ?? '';
  const hit = KEYWORDS.find((k) => k.match.test(name));
  if (hit) return hit.emoji;
  return durationEmoji(instance.duration ?? 0);
};
